import { useNavigate } from 'react-router-dom';
import TopBarHeader from '@/domains/mobile-web/components/TopBarHeader/TopBarHeader';
import {
  TNC_CLOSING,
  TNC_INTRO,
  TNC_SECTIONS,
  TNC_TITLE,
  type TncSection,
} from '@/domains/mobile-web/constant/tnc.constant';
import WrapperMobile from '@/shared/components/layout/WrapperMobile/WrapperMobile';
import HeaderMobile from '@/shared/components/ui/HeaderMobile/HeaderMobile';
import Seo from '@/shared/components/ui/Seo/Seo';

const Section = ({ title, intro, items, bullets, outro }: TncSection) => (
  <section className="flex! flex-col gap-3">
    <h2 className="title3 text-black">{title}</h2>
    {intro?.map((paragraph) => (
      <p key={paragraph} className="reg12 text-text-grey">
        {paragraph}
      </p>
    ))}
    {items &&
      (bullets ? (
        <ul className="reg12 text-text-grey flex flex-col gap-1">
          {items.map((item) => (
            <li key={item}>- {item}</li>
          ))}
        </ul>
      ) : (
        <ol className="reg12 text-text-grey flex flex-col gap-1">
          {items.map((item, index) => (
            <li key={item}>
              {index + 1}. {item}
            </li>
          ))}
        </ol>
      ))}
    {outro?.map((paragraph) => (
      <p key={paragraph} className="reg12 text-text-grey">
        {paragraph}
      </p>
    ))}
  </section>
);

const Tnc = () => {
  const navigate = useNavigate();

  return (
    <>
      <Seo
        title="Syarat & Ketentuan"
        description="Syarat dan Ketentuan penggunaan website dan layanan Rumah Kebijaksanaan: pendaftaran akun, pembelian buku, pengembalian, program afiliasi, donasi dan permintaan buku."
        path="/store/tnc"
      />
      <HeaderMobile>
        <TopBarHeader type="back" title="Syarat & Ketentuan" onBack={() => navigate(-1)} />
      </HeaderMobile>

      <WrapperMobile>
        <article className="flex flex-col gap-6">
          <section className="flex! flex-col gap-3">
            <h1 className="title3bold text-black uppercase">{TNC_TITLE}</h1>
            <p className="reg12 text-text-grey">{TNC_INTRO}</p>
          </section>

          {TNC_SECTIONS.map((section) => (
            <Section key={section.title} {...section} />
          ))}

          <p className="reg12 text-text-grey">{TNC_CLOSING}</p>
        </article>
      </WrapperMobile>
    </>
  );
};

export default Tnc;
